
import GHObject from './GHObject';

export default class GHGeometryObject extends GHObject {
  constructor (ghObject, hidden = false) {
    super();

    Object.assign(this, ghObject);

    this.hidden = hidden;
    this.inputParams = [];
    this.outputParams = [];
    /*
    this.objectType = ghObject.objectType
    this.nickName = ghObject.nickName
    this.instanceGuid = ghObject.instanceGuid
    */
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHGeometryObject.js